import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = { class: "mt-16 flex items-center border-b border-black-400" }
const _hoisted_3 = ["placeholder", "aria-label"]
const _hoisted_4 = {
  type: "submit",
  class: "btn btn-xsmall text-black-900 hover:text-black-600"
}
const _hoisted_5 = { class: "fallback-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("form", {
    class: "grid w-full bg-white transition-grid-template-rows duration-300",
    role: "search",
    autocomplete: "off",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.$emit('isSubmitted', $data.searchTerm)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($data.searchTerm !== '')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.clearSearch && $options.clearSearch(...args)))
            }, [
              _createVNode(_component_v_icon, {
                icon: "refresh",
                height: 12.8,
                width: 16,
                class: "mr-2"
              })
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          ref: "inputRef",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchTerm) = $event)),
          type: "search",
          placeholder: $data.locale.input_placeholder,
          "aria-label": $data.locale.input_placeholder,
          class: "product-search grow text-14 placeholder:text-black-400"
        }, null, 8, _hoisted_3), [
          [_vModelText, $data.searchTerm]
        ]),
        _createElementVNode("button", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { "aria-hidden": "true" }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString($data.locale.search_button), 1)
        ])
      ])
    ])
  ], 32))
}